import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col,Image, Button} from "react-bootstrap";
import ClientLogoFive from "../../../assests/images/about-great-non-profit-image/the-huffington-post.webp";
import EarthImage from "../../../assests/images/about-great-non-profit-image/earth-image.webp";
import BillGates from "../../../assests/images/about-great-non-profit-image/bill-gates.webp";
import MarkHoewing from "../../../assests/images/about-great-non-profit-image/mark-hoewing.webp";
import BrianWalsh from "../../../assests/images/about-great-non-profit-image/brian-walsh.webp";
import TopRatedImage from "../../../assests/images/About-top-rated-awards-images/top-rated-awards.png";
import DonorsBlogImageOne from "../../../assests/images/about-great-non-profit-image/donors-blog-image-one.webp";
import DonorsBlogImageTwo from "../../../assests/images/about-great-non-profit-image/donors-blog-image-two.webp";
import SocialMediaPhoto from "../../../assests/images/about-great-non-profit-image/social-media-image.svg";
import FacebookIcon from "../../../assests/images/blog-page-images/white-facebook.svg";
import TwitterIcon from "../../../assests/images/blog-page-images/white-twitter-x.svg";
import InstagramIcon from "../../../assests/images/blog-page-images/white-instagram.svg";
import LinkedinIcon from "../../../assests/images/blog-page-images/white-linkedin.svg";
import TeamMemberOne from "../../../assests/images/about-great-non-profit-image/perla-nii.webp";
import SiliconValley from "../../../assests/images/about-great-non-profit-image/silicon-valley.webp";
import CharitableFund from "../../../assests/images/about-great-non-profit-image/charitable-fund.webp";
import OurBoardMembers from "./OurBoardMembers/OurBoardMembers";
import {
AboutGreatNonprofitSection,
EndorsementsSection,
ClientLogoWrap,
ClientLogoBox,
ClientBgImage,
EndorsementsClientWrap,
EndorsementsClientButton,
EndorsementsClientBox,
EndorsementsClientImageBox,
EndorsementsClientImage,
EndorsementsClientText,
EndorsementsClientSubTitle,
EndorsementsClientName,
EndorsementsClientDesignation,
NonProfitsCta,
NonProfitsCtaBox,
NonProfitsCtaBoxTitle,
NonProfitsCtaBoxText,
InspiringInformingSection,
InspiringInformingWrap,
InspiringInformingTitle,
InspiringInformingText,
InspiringInformingButton,
InspiringInformingImage,
InspiringInformingDonors,
InspiringDonorsImage,
InspiringDonorsContent,
InspiringDonorsSubTitle,
InspiringDonorsText,
InspiringInformingDonorsWrap,
SocialMediaSection,
SocialMediaWrap,
SocialMediaContent,
SocialMediaImage,
SocialMediaTitle,
SocialMediaIcon,
GreatNonprofitsTeamSection,
GreatNonprofitsTeamTopGroup,
GreatNonprofitsTeamTitle,
GreatNonprofitsTeamButton,
TeamMemberWrap,
TeamMemberImage,
TeamMemberContent,
TeamMemberName,
TeamMemberDesignation,
TeamMemberText,
TeamMemberTextStrong,
BoardMemberSection,
ProjectMadeSection,
ProjectMadeWrap,
ProjectMadeTitle,
ProjectMadeLogoBox,
ProjectMadeLogoWrap,
AdvisoryBoardGroup,
BoardMembersBox,
AboutQuote,
AboutBottom,
} from "./aboutGreatNonprofitStyle";
import {
Title,
WriteReviewSection,
ReviewText,
ReviewRightSection,
RightBanner,
} from "../../../components/common/commonSubBanner/commonSubBannerStyle";
import AnnieSprattBanner from "../../../assests/images/annie-spratt-banner.webp";
import larmRmahBanner from "../../../assests/images/larm-rmah-banner.webp";
import PexelsMatheusBanner from "../../../assests/images/pexels-matheus-banner.webp";
import { useNavigate } from "react-router-dom";
import { MESSAGE } from "../../../utils/message";
import { useDispatch,useSelector } from "react-redux";
import { greatNonProfitHandler } from "../../../redux/slices/about/about-great-nonprofit";
import { aboutMembersHandler } from "../../../redux/slices/members/about-members";
import MetaComponent from "../../../components/common/metaComponent";

const AboutGreatNonprofit = () => {   
const navigate = useNavigate()
const dispatch:any = useDispatch()
const clientReview = useSelector((state:any) => state?.greatNonProfit?.data)
const aboutMembersData = useSelector((state:any) => state?.aboutMembers?.data)
useEffect(() => {
dispatch(greatNonProfitHandler())
dispatch(aboutMembersHandler())
},[])
return (
<>
<MetaComponent 
            keywords=""
            description="The GreatNonprofits Info Site"
            ogTitle="About GreatNonprofits"
            ogDescription="The GreatNonprofits Info Site"
            ogUrl="https://www.about.greatnonprofits.org"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
<AboutGreatNonprofitSection>
   <WriteReviewSection className="about-great-nonprofit-banner">
      <Container className="cont-w">
         <Row>
            <Col lg={6} sm={12} md={12}>
            <Title className="about-great-title">
              {MESSAGE.aboutGreatNonprofit}
            </Title>
            <ReviewText className="about-great-text">
             {MESSAGE.greatNonprofitDetailText}
             </ReviewText>
            <Button className="btn-outline-success-blue" onClick={() => navigate("/about/get-started")}>
            {MESSAGE.greatNonprofitButton}
            </Button>
            </Col>
            <Col lg={6} sm={12} md={12}>
            <RightBanner className="left_banner">
               <ReviewRightSection className="about-img-profit">
                  <AboutQuote className="abiou-quote_col">
                     <Image src={larmRmahBanner} />
                  </AboutQuote>
                  <AboutBottom className="abut_bottom_col">
                     <Image src={PexelsMatheusBanner} />
                  </AboutBottom>
                  <Image src={AnnieSprattBanner} alt="ReviewImage" />
               </ReviewRightSection>
            </RightBanner>
            </Col>
         </Row>
      </Container>
   </WriteReviewSection>
</AboutGreatNonprofitSection>
<EndorsementsSection>
   <Container className="cont-w">
      <Row>
         <Col lg="6">
         <ClientLogoWrap>
            {clientReview?.data?.clientLogos?.map((client:any, index:number) => (
            <ClientLogoBox key={index+1}>
               <Image src={ClientLogoFive} alt={client} />
            </ClientLogoBox>
            ))}
         </ClientLogoWrap>
         </Col>
         <Col lg="6">
         <ClientBgImage>
            <Image src={EarthImage} alt="Earth image" />
         </ClientBgImage>
         </Col>
      </Row>
      <Row>
         <Col lg="9">
         <EndorsementsClientWrap>
         {clientReview?.data?.appreciationsBy?.map((client: any, index: number) => {
  let imageSrc;

  if (client.name === 'Bill Gates') {
    imageSrc = BillGates;
  } else if (client.name === 'Mark Hoewing') {
    imageSrc = MarkHoewing;
  } else {
    imageSrc = BrianWalsh;
  }

  return (
    <EndorsementsClientBox key={index + 1}>
      <EndorsementsClientImageBox>
        <EndorsementsClientImage>
          <Image src={imageSrc} alt={client.name} />
        </EndorsementsClientImage>
        <EndorsementsClientText>&#8223;{`${client.quote}`}&#8223;</EndorsementsClientText>
      </EndorsementsClientImageBox>
      <EndorsementsClientName>
        <EndorsementsClientSubTitle>{client.name}</EndorsementsClientSubTitle>
        <EndorsementsClientDesignation>{client.firmName}</EndorsementsClientDesignation>
      </EndorsementsClientName>
    </EndorsementsClientBox>
  )
})}

         </EndorsementsClientWrap>
         </Col>
         <Col lg="3">
         <EndorsementsClientButton onClick={() => navigate("/about/endorsements")}>
            <Button className="btn-outline-success-blue" onClick={() => navigate('/about/endorsements')}>See All Endorsements</Button>
         </EndorsementsClientButton>
         </Col>
      </Row>
   </Container>
</EndorsementsSection>
<NonProfitsCta>
   <Container className="cont-w">
      <Row>
         <Col sm="12">
         <NonProfitsCtaBox>
            <NonProfitsCtaBoxTitle>
              {MESSAGE.aboutGreatNonprofitHeadline}
            </NonProfitsCtaBoxTitle>
            <NonProfitsCtaBoxText>
             {MESSAGE.aboutGreatNonprofitDetail}
            </NonProfitsCtaBoxText>
         </NonProfitsCtaBox>
         </Col>
      </Row>
   </Container>
</NonProfitsCta>
<InspiringInformingSection>
   <Container className="cont-w">
      <Row className="inspiring-informing-group">
         <Col lg="6">
         <InspiringInformingImage>
            <Image src={TopRatedImage} alt="Top Rated Image" />
         </InspiringInformingImage>
         </Col>
         <Col lg="6">
         <InspiringInformingWrap>
            <InspiringInformingTitle>
             {MESSAGE.inspireDonor}
            </InspiringInformingTitle>
            <InspiringInformingText>
               {MESSAGE.inspireDonorText}
            </InspiringInformingText>
            <InspiringInformingButton>
               <Button className="btn-outline-success-blue"  onClick={() => navigate('/detail-award')}>Learn About the Top-Rated Awards</Button>
            </InspiringInformingButton>
         </InspiringInformingWrap>
         </Col>
      </Row>
      <Row>
         <Col lg="12">
         <InspiringInformingDonorsWrap>
            <InspiringInformingDonors>
               <InspiringDonorsImage>
                  <Image src={DonorsBlogImageOne} alt="Donors Blog Image One"/>
               </InspiringDonorsImage>
               <InspiringDonorsContent>
                  <InspiringDonorsSubTitle>{MESSAGE.inspireInform}</InspiringDonorsSubTitle>
                  <InspiringDonorsText>{MESSAGE.inspireInformText}</InspiringDonorsText>
               </InspiringDonorsContent>
            </InspiringInformingDonors>
            <InspiringInformingDonors>
               <InspiringDonorsImage>
                  <Image src={DonorsBlogImageTwo} alt="Donors Blog Image Two"/>
               </InspiringDonorsImage>
               <InspiringDonorsContent>
                  <InspiringDonorsSubTitle>{MESSAGE.loyalSupporters}</InspiringDonorsSubTitle>
                  <InspiringDonorsText>{MESSAGE.loyalSupportersText}</InspiringDonorsText>
               </InspiringDonorsContent>
            </InspiringInformingDonors>
         </InspiringInformingDonorsWrap>
         </Col>
      </Row>
   </Container>
</InspiringInformingSection>
<SocialMediaSection>
   <Container className="cont-w">
      <Row>
         <Col lg="12">
         <SocialMediaWrap>
            <SocialMediaContent>
               <SocialMediaTitle>{MESSAGE.socialMediaInviteText}</SocialMediaTitle>
               <SocialMediaIcon>
                  <a 
                  href="https://www.facebook.com/"
                  className="social-media-icon-bg"
                  target="_blank"
                  rel="noreferrer">
                     <Image src={FacebookIcon} alt="facebook" />
                  </a>
                  <a 
                  href="https://x.com/i/flow/login" 
                  className="social-media-icon-bg" 
                  target="_blank" 
                  rel="noreferrer">
                     <Image src={TwitterIcon} alt="twitter" />
                  </a>
                  <a 
                  href="https://www.instagram.com/accounts/login" 
                  className="social-media-icon-bg" 
                  target="_blank" 
                  rel="noreferrer">
                     <Image src={InstagramIcon} alt="instagram" />
                    </a>
                  <a 
                  href="https://www.linkedin.com/login" 
                  className="social-media-icon-bg"
                  target="_blank" 
                  rel="noreferrer">
                     <Image src={LinkedinIcon} alt="linkedin" />
                  </a>
               </SocialMediaIcon>
            </SocialMediaContent>
            <SocialMediaImage>
               <Image src={SocialMediaPhoto} alt="Social media image" />
            </SocialMediaImage>
         </SocialMediaWrap>
         </Col>
      </Row>
   </Container>
</SocialMediaSection>
<GreatNonprofitsTeamSection>
   <Container className="cont-w">
      <Row>
         <Col lg="12">
         <GreatNonprofitsTeamTopGroup>
            <GreatNonprofitsTeamTitle>
              {MESSAGE.greatNonprofitTeam}
            </GreatNonprofitsTeamTitle>
            <GreatNonprofitsTeamButton>
               <Button className="btn-outline-success-blue"  onClick={() => navigate('/about/team')}>See All Team Members</Button>
            </GreatNonprofitsTeamButton>
         </GreatNonprofitsTeamTopGroup>
         <TeamMemberWrap>
            <TeamMemberImage>
               <Image src={TeamMemberOne} alt="Perla Nii" />
            </TeamMemberImage>
            <TeamMemberContent>
               <TeamMemberName> {aboutMembersData?.data?.teamMembers[0]?.name}</TeamMemberName>
               <TeamMemberDesignation>
                  {aboutMembersData?.data?.teamMembers[0]?.profession}
               </TeamMemberDesignation>
               <TeamMemberText>
                  <TeamMemberTextStrong>{aboutMembersData?.data?.teamMembers[0]?.name},</TeamMemberTextStrong>
                  {" "}
                  {aboutMembersData?.data?.teamMembers[0]?.about}
               </TeamMemberText>
            </TeamMemberContent>
         </TeamMemberWrap>
         </Col>
      </Row>
   </Container>
</GreatNonprofitsTeamSection>
<BoardMemberSection>
   <Container className="cont-w">
      <Row>
         <Col lg="12">
         <GreatNonprofitsTeamTopGroup>
            <GreatNonprofitsTeamTitle>
               {MESSAGE.ourBoardMembers}
            </GreatNonprofitsTeamTitle>
            <GreatNonprofitsTeamButton>
               <Button className="btn-outline-success-blue"  onClick={() => navigate('/about/board-members')}>{MESSAGE.seeAllBoardMembers}</Button>
            </GreatNonprofitsTeamButton>
         </GreatNonprofitsTeamTopGroup>
         <BoardMembersBox>
            {aboutMembersData?.data?.boardMembers?.slice(0,4)?.map((member:any,index:number) => (
            <OurBoardMembers memberDetail={member} key={index+1}/>
            ))} 
         </BoardMembersBox>
         </Col>
      </Row>
   </Container>
</BoardMemberSection>
<BoardMemberSection>
   <Container className="cont-w">
      <Row>
         <Col lg="12">
         <GreatNonprofitsTeamTopGroup>
            <GreatNonprofitsTeamTitle>
               {MESSAGE.ourAdvisoryBoard}
            </GreatNonprofitsTeamTitle>
            <GreatNonprofitsTeamButton>
               <Button className="btn-outline-success-blue"  onClick={() => navigate('/about/advisory-board')}>{MESSAGE.seeAllAdvisoryBoard}</Button>
            </GreatNonprofitsTeamButton>
         </GreatNonprofitsTeamTopGroup>
         <AdvisoryBoardGroup>
            {aboutMembersData?.data?.advisoryBoardMembers?.slice(0,4)?.map((member:any,index:number) => (
            <OurBoardMembers memberDetail={member} key={index+1}/>
            ))}
         </AdvisoryBoardGroup>
         </Col>
      </Row>
   </Container>
</BoardMemberSection>
<ProjectMadeSection>
   <Container className="cont-w">
      <Row>
         <Col lg="12">
         <ProjectMadeWrap>
            <ProjectMadeTitle>
               {MESSAGE.projectGrantText}
            </ProjectMadeTitle>
            <ProjectMadeLogoWrap>
               <ProjectMadeLogoBox>
                  <Image src={SiliconValley} alt="silicon valley" />
               </ProjectMadeLogoBox>
               <ProjectMadeLogoBox>
                  <Image src={CharitableFund} alt="silicon valley" />
               </ProjectMadeLogoBox>
            </ProjectMadeLogoWrap>
         </ProjectMadeWrap>
         </Col>
      </Row>
   </Container>
</ProjectMadeSection>
</>
);
};
export default AboutGreatNonprofit;